import src from "IMAGE";
export default { src, width: 1517, height: 796, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASklEQVR42oWNwQmAMAwAs/9YpRDzUEKwFn2ZBfw4wAl2gN7r4B4nTBBT5QnnWpRSCmaG6vCIQM7eeY+de1txd1prf6i1kpnIbPEBiGN2ps7GvSEAAAAASUVORK5CYII="};
